import { LOCALES } from '@survey/core';
import { Languages } from 'lucide-react';
import { useI18n } from '../i18n';

/** Compact EN | ID segmented control. */
export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { locale, setLocale, t } = useI18n();
  return (
    <div className={`lang-switch ${compact ? 'compact' : ''}`} role="group" aria-label={t('lang.label')}>
      {!compact && <Languages aria-hidden className="lang-icon" />}
      {LOCALES.map((l) => (
        <button
          key={l.code}
          type="button"
          className={locale === l.code ? 'active' : ''}
          aria-pressed={locale === l.code}
          title={l.label}
          lang={l.tag}
          onClick={() => setLocale(l.code)}
        >
          {l.code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
